import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=bb37f3d2&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb37f3d2')) {
      api.createRecord('bb37f3d2', component.options)
    } else {
      api.reload('bb37f3d2', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=bb37f3d2&", function () {
      api.rerender('bb37f3d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/locale/edit.vue"
export default component.exports